import { withHandlers } from 'recompose';
import { SentryService } from '../../../modules/infra/observability/sentry';
import Http from '../../http';
import { Logger } from '../../../modules/infra/observability/logger';

export default withHandlers({
  testCaptureException: () => () => SentryService.captureException(new Error('Test Sentry captureException')),
  testThrowError: () => () => { throw new Error('Test Sentry error capturing'); },
  testObjectError: () => () => {
    Http.get('/some-stuff').catch((err) => {
      SentryService.captureException(err);
    });
  },
  testLogger: () => () => {
    Logger.log('test log', { message: 'test' });
  },
});
